export const COLOR_VERYLIGHT = "#bdfad4";
export const COLOR_LIGHT = "#72db9b";
export const COLOR_MEDIUM = "#66aec0";
export const COLOR_DARK = "#003b6b";
export const COLOR_MEDIUMDARK = "rgb(0, 76, 138)"
export const COLOR_HIGHLIGHTED = "#fff345";
export const COLOR_DIVISOR = "#FFC0C0";
export const FONT = "Lexend Deca, sans-serif";
export const ROMAN_FONT = "Cinzel, serif";
export const BINARY_FONT = "Orbit, sans-serif";
export const MAYA_FONT = "Passero One, sans-serif";
export const REPEATS = 3;
export const ROMAN_SYSTEM = 0;
export const BINARY_SYSTEM = 1;
export const MAYA_SYSTEM = 2;
export const NUMBER_OF_SYSTEMS = 3;
export const ROMAN_NUMBER_OF_LEVELS = 6;
export const BINARY_NUMBER_OF_LEVELS = 8;
export const MAYA_NUMBER_OF_LEVELS = 5;
export const REGEX_VALID_ROMAN = "^(?=[MDCLXVImdclxvi])[Mm]*[Dd]?[Cc]{0,4}[Ll]?[Xx]{0,4}[Vv]?[Ii]{0,4}$"; // LLM-generated. Only allows additive notation.
export const REGEX_VALID_BINARY = "(^0$|^1[01]*$)"; // May only start with a 0, if is number zero.
export const REGEX_VALID_DECIMAL = "^0|[1-9][0-9]*$";
